import * as React from "react";
import { IconProps } from "./types";

export const AlignRight01Icon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          d="M21 21V3M3 12H17M17 12L10 5M17 12L10 19"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          stroke={color}
        />
      </svg>
    );
  },
);
(AlignRight01Icon as React.FunctionComponent).displayName = "AlignRight01Icon";

export default AlignRight01Icon;
